import { render, staticRenderFns } from "./paye-remitance.vue?vue&type=template&id=f6a5a732&"
import script from "./paye-remitance.vue?vue&type=script&lang=js&"
export * from "./paye-remitance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6a5a732')) {
      api.createRecord('f6a5a732', component.options)
    } else {
      api.reload('f6a5a732', component.options)
    }
    module.hot.accept("./paye-remitance.vue?vue&type=template&id=f6a5a732&", function () {
      api.rerender('f6a5a732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/paye/paye-remitance.vue"
export default component.exports